/* eslint-disable react/forbid-prop-types */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import { Row, Col } from 'reactstrap';
import NumberFormat from 'react-currency-format';
import PropTypes from 'prop-types';
import { setRUTFormat } from '../../../shared/utils';

const ClientInformation = ({ entry }) => (
  <div className='crm-lateral-personal-data'>
    <h4 className="mb-2">
      <strong>Datos Personales</strong>
    </h4>
    <Row>
      <Col>
        <label className="label_porfolio">Nombre</label>
        <br />
        <label>{entry.NombreCliente !== undefined && entry.NombreCliente}</label>
      </Col>
      <Col>
        <label className="label_porfolio">Rut</label>
        <br />
        <label>{entry.RutCliente && setRUTFormat(entry.RutCliente)}</label>
      </Col>
      <Col>
        <label className="label_porfolio">Nacionalidad</label>
        <br />
        <label>{entry.NacionalidadCliente}</label>
      </Col>
      <Col>
        <label className="label_porfolio">Codigo</label>
        <br />
        <label>{entry.CodigoCliente}</label>
      </Col>
    </Row>
    <Row>
      <Col>
        <label className="label_porfolio">Fecha Nacimiento</label>
        <br />
        <label>{entry.FecNacimientoCliente}</label>
      </Col>
      <Col>
        <label className="label_porfolio">Estado Civil</label>
        <br />
        <label>{entry.EstadoCivilCliente}</label>
      </Col>
      <Col>
        <label className="label_porfolio">Genero</label>
        <br />
        <label>{entry.SexoCliente}</label>
      </Col>
      <Col>
        <label className="label_porfolio">Correo</label>
        <br />
        <label>{entry.EmailsCliente !== undefined && entry.EmailsCliente.length > 0 && entry.EmailsCliente[0].Email}</label>
      </Col>
    </Row>
    <Row>
      <Col>
        <label className="label_porfolio">Teléfono</label>
        <br />
        <label>{entry.TelefonosCliente !== undefined && entry.TelefonosCliente.length > 0 && entry.TelefonosCliente[0].NroTelefono}</label>
      </Col>
      <Col>
        <label className="label_porfolio">Dirección</label>
        <br />
        <label>
          {entry.DireccionesCliente && entry.DireccionesCliente[0].Calle} {entry.DireccionesCliente && entry.DireccionesCliente[0].CodigoDireccion}
        </label>
      </Col>
      <Col>
        <label className="label_porfolio">Comuna</label>
        <br />
        <label>{entry.DireccionesCliente && entry.DireccionesCliente[0].Comuna}</label>
      </Col>
      <Col>
        <label className="label_porfolio">Región</label>
        <br />
        <label>{entry.DireccionesCliente && entry.DireccionesCliente[0].Region}</label>
      </Col>
    </Row>
    <h4 className="mb-2 mt-3">
      <strong>Datos Laborales</strong>
    </h4>
    <Row>
      <Col>
        <label className="label_porfolio">Situación Laboral</label>
        <br />
        <label>{entry.TipoCliente}</label>
      </Col>
      <Col>
        <label className="label_porfolio">Sueldo Fijo</label>
        <br />
        <label>
          <NumberFormat
            value={entry.SueldoFijoCliente}
            displayType="text"
            decimalSeparator=","
            thousandSeparator="."
            prefix="$"
          />
        </label>
      </Col>
      <Col>
        <label className="label_porfolio">Sueldo Variable</label>
        <br />
        <label>
          <NumberFormat
            value={entry.SueldoVariableCliente}
            displayType="text"
            decimalSeparator=","
            thousandSeparator="."
            prefix="$"
          />
        </label>
      </Col>
      <Col />
    </Row>
  </div>
);

ClientInformation.propTypes = {
  entry: PropTypes.object.isRequired,
};

export default ClientInformation;
